import { createStore } from '../_core/createStore';
import { lazyDependency } from '../_core/lazyDependency';
import useApiStore from '../apiStore/useApiStore';
import { leadChannelStore } from './leadChannelStore';

const useLeadChannelStore = createStore({
  creator: leadChannelStore({
    useApiStore: lazyDependency(() => useApiStore),
  }),
  id: 'leadChannel',
  middlewares: {
    devtools: true,
  },
});

export default useLeadChannelStore;
